const ITEMS = [
    "SPACES THAT MOVE",
    "LIGHT THAT LIVES",
    "MOTION BECOMES ART",
    "TECHNOLOGY DISAPPEARS BEHIND BEAUTY",
    "WE CREATE MOMENTS PEOPLE REMEMBER",
];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/5 py-8" aria-hidden="true">
            <div className="marquee-track flex w-max items-center gap-16 whitespace-nowrap">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center gap-16">
                        {row.map((t, i) => (
                            <span key={`${half}-${i}`} className="flex items-center gap-16">
                                <span className="font-display text-xl font-medium uppercase tracking-[0.2em] text-white/25 md:text-2xl">{t}</span>
                                <span className="h-1 w-1 rounded-full bg-[#FFE8B6]/40 shadow-[0_0_10px_2px_rgba(255,214,140,0.3)]" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
